__turbopack_context__.v({
  "className": "comic_neue_84d0ebc4-module__gVNRrW__className",
});
